import React, {Component} from 'react';
import {TableRowComponent} from 'components/organisms/players-to-exchange/table-elements/table-row-component';
import TableHeadComponent from 'components/organisms/players-to-exchange/table-elements/table-head-component';
import PlayerInterface from 'interfaces/players-data-interfaces/player-interface';
import LineupInterface from 'interfaces/lineups-data-interfaces/lineup-interface';
import {sortByProperty} from 'helpers/sorters';
import TableBuilderProvider from 'components/organisms/players-to-exchange/available-players/table-builder-provider';
import Const from 'const';

interface Props {
    substitutePlayers: Array<PlayerInterface>;
    substitutablePlayer: PlayerInterface;
    lineup: LineupInterface;
    maxTotalSalary: number;
    currentTotalSalary: number;
    sportConfig;
}

class AvailablePlayersList extends Component<Props> {
    private tableBuilder = TableBuilderProvider.provide(this.props.sportConfig);

    private isPlayerBeyondSalaryCap(player, substitutablePlayer, maxTotalSalary, currentTotalSalary) {
        let substitutablePlayerSalary = substitutablePlayer.salary;
        let playerToSwapSalary = player.salary;

        if (inArray(substitutablePlayer.lineupRole, [Const.CAPTAIN_MODE, Const.STAR_MODE, Const.PRO_MODE])) {
            substitutablePlayerSalary = substitutablePlayer.getPropValueOfMode(
                'salary',
                substitutablePlayer.lineupRole,
            );
            playerToSwapSalary = player.getPropValueOfMode('salary', substitutablePlayer.lineupRole);
        }

        return currentTotalSalary - substitutablePlayerSalary + playerToSwapSalary > maxTotalSalary;
    }

    render() {
        const {substitutePlayers, substitutablePlayer, lineup, maxTotalSalary, currentTotalSalary} = this.props;

        return (
            <table className="table table-players">
                <thead>
                    <tr>
                        {this.tableBuilder.getTableHead().map((heading, index) => {
                            return <TableHeadComponent key={index} heading={heading} />;
                        })}
                    </tr>
                </thead>
                <tbody>
                    {substitutePlayers.sort(sortByProperty('salary', 'desc')).map((player, index) => {
                        const isPlayerBeyondSalaryCap = this.isPlayerBeyondSalaryCap(
                            player,
                            substitutablePlayer,
                            maxTotalSalary,
                            currentTotalSalary,
                        );

                        return (
                            <TableRowComponent
                                key={index}
                                player={this.tableBuilder.getTableBody(player, substitutablePlayer, lineup)}
                                isPlayerBeyondSalaryCap={isPlayerBeyondSalaryCap}
                            />
                        );
                    })}
                </tbody>
            </table>
        );
    }
}

export {AvailablePlayersList};
